import DQS from './DynamicQuantitySelect.jsx';

export const DynamicQuantitySelect = DQS;
export default DQS;
